<template>
  <div>
    <div class="hot_nav">
      <span class="hot_nav_text">热门推荐</span>
      <span class="hot_nav_text_link" @click="goTo">更多></span>
    </div>
    <div class="OMG">
      <ul class="wrapper">
        <li v-for="(item,index) in list" :key="index" @click="go(item.id,item.image)">
          <img :src="item.image" alt>
          <p class="user_name">{{item.name}}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { videovideo } from "../../api/my";
import secret from "../../assets/js/utils";
export default {
  data() {
    return {
      list: [],
      page: 1
    };
  },
  methods: {
    goTo() {
      this.$router.push("./classification");
    },
    go(id,image) {
      this.$router.push({
        path: "./video_details",
        query: { 
          id: id,
          pic:image
         }
      });
      console.log(id);
    },
    loading() {
      let params = {};
      params.page = this.page++;
      let params_stringify = JSON.stringify(params);
      let params_Encrypt = secret.Encrypt(params_stringify);
      videovideo({
        params: params_Encrypt
      }).then(res => {
        res = res.data;
        let res_data = secret.Decrypt(res);
        let data = JSON.parse(res_data);
        if (data.code == 1) {
           
          this.list = data.data.data;
          // console.log(this.list);
        }
      });
    }
  },
  created() {
    
    this.loading();
  }
};
</script>

<style scoped lang="less">
.hot_nav {
  width: 88%;
  height: 0.3rem;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .hot_nav_text {
    font-family: "PingFangSC-Regular";
    font-size: 0.26rem;
    font-weight: bold;
    color: #fff;
    letter-spacing: 2px;
  }
  .hot_nav_text_link {
    width: 0.85rem;
    height: 0.4rem;
    text-align: center;
    line-height: 0.35rem;
    font-size: 0.2rem;
    color: black;
    border-radius: 15px;
    border: 2px solid #c2c1c9;
    background: #fff;
  }
}
.OMG {
  width: 90%;
  height: 0.6rem;
  margin: auto;
  .wrapper {
    width: 100%;
    white-space: nowrap;
    overflow-x: scroll;
    margin-top: 10px;
    li {
      display: inline-block;
      text-align: center;
      border-radius: 8px;
      width: 2.2rem;
      height: 2.7rem;
      margin-left: 10px;
      img {
        width: 2.2rem;
        height: 2.5rem;
        object-fit: cover;
      }
    }
    li:last-child {
      margin-right: 10px;
    }
    .user_name {
      font-size: 0.25rem;
      color: #fff;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .wrapper::-webkit-scrollbar {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Vocal_Novels/hotVideo.vue